<i18n>
{
  "de": {
    "title": "Farben anpassen",
    "description": "Deine Änderungen werden erst beim Speichern öffentlich.",
    "save": "Speichern",
    "reset": "Zurücksetzen",
    "backgrounds": "Hintergründe",
    "primaryAccent": "Primärer Akzent",
    "secondaryAccent": "Sekundärer Akzent",
    "tertiaryAccent": "Tertiärer Akzent",
    "page": "Seite",
    "tiles": "Kacheln",
    "posts": "Beiträge",
    "stickyPosts": "Angeheftete Beiträge",
    "product": "Produkte",
    "commentsBackground": "Kommentare"
  },
  "en": {
    "title": "Change colors",
    "description": "Your changes only become public when you save them.",
    "save": "Save",
    "reset": "Reset",
    "backgrounds": "Backgrounds",
    "primaryAccent": "Primary Accent",
    "secondaryAccent": "Secondary Accent",
    "tertiaryAccent": "Tertiary Accent",
    "page": "Page",
    "tiles": "Tiles",
    "posts": "Posts",
    "stickyPosts": "Sticky posts",
    "product": "Products",
    "commentsBackground": "Comments"
  }
}
</i18n>

<template>
  <div class="color-menu-content">
    <h3
      class="title is-4"
      style="color: #000;"
    >
      {{ $t('title') }}
    </h3>
    <p class="pb-10">
      {{ $t('description') }}
    </p>
    <div class="is-flex is-flex-direction-column">
      <colorPicker
        :colorName="'primary'"
        :label="$t('primaryAccent')"
        :value="profileColorStyles.primary"
        @color-changed="handleColorChange"
      />
      <colorPicker
        :colorName="'secondary'"
        :label="$t('secondaryAccent')"
        :value="profileColorStyles.secondary"
        class="mt-10"
        @color-changed="handleColorChange"
      />
      <colorPicker
        :colorName="'tertiary'"
        :label="$t('tertiaryAccent')"
        :value="profileColorStyles.tertiary"
        class="mt-10"
        @color-changed="handleColorChange"
      />
      <hr class="mt-10 mb-0">
      <h3
        class="title is-6 mt-10 mb-0"
        style="color: #000;"
      >
        {{ $t('backgrounds') }}
      </h3>
      <colorPicker
        :colorName="'commentsBackground'"
        :label="$t('commentsBackground')"
        :value="profileColorStyles.commentsBackground"
        class="mt-10"
        @color-changed="handleColorChange"
      />
      <colorPicker
        :colorName="'bodyBackground'"
        :label="$t('page')"
        :value="profileColorStyles.bodyBackground"
        class="mt-10"
        @color-changed="handleColorChange"
      />
      <colorPicker
        :colorName="'productBackground'"
        :label="$t('product')"
        :value="profileColorStyles.productBackground"
        class="mt-10"
        @color-changed="handleColorChange"
      />
      <colorPicker
        :colorName="'tilesBackground'"
        :label="$t('tiles')"
        :value="profileColorStyles.tilesBackground"
        class="mt-10"
        @color-changed="handleColorChange"
      />
      <colorPicker
        :colorName="'postsBackground'"
        :label="$t('posts')"
        :value="profileColorStyles.postsBackground"
        class="mt-10"
        @color-changed="handleColorChange"
      />
      <colorPicker
        :colorName="'stickyPostsBackground'"
        :label="$t('stickyPosts')"
        :value="profileColorStyles.stickyPostsBackground"
        class="mt-10"
        @color-changed="handleColorChange"
      />
    </div>

    <div class="mt-20 is-flex is-justify-content-space-between">
      <button
        class="button same-min-width is-primary"
        @click.prevent="save"
      >
        {{ $t('save') }}
      </button>
      <button
        class="button same-min-width is-secondary"
        @click.prevent="reset"
      >
        {{ $t('reset') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import colorPicker from '~/components/color-picker'

const debounce = (func, wait) => {
  let timeout
  return function (...args) {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => func.apply(context, args), wait)
  }
}

export default {
  name: 'ColorMenuContent',
  components: { colorPicker },
  computed: {
    ...mapState(['profileColorStyles'])
  },
  methods: {
    handleColorChange: debounce(function ({ colorName, value }) {
      this.$store.commit('setProfileColor', { colorName, value })
    }, 200),
    reset() {
      this.$store.dispatch('resetProfileColorStyles')
    },
    async save() {
      await this.$store.dispatch('saveProfileColorStyles')
      this.$emit('saved')
    }
  }
}
</script>

<style lang="scss" scoped>
.color-menu-content {
  padding: 20px;
  color: black;

  button.same-min-width {
    min-width: 100px;
  }
}
</style>
